/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { ClickableIconViewModel } from 'src/types/view-models/clickable-icon.view.model';

// styles
import styles from './ClickableIcon.module.scss';

export default class ClickableIcon extends Component<ClickableIconViewModel, { filled: boolean }> {
    public override state = {
        filled: false
    };

    public override render(): ReactComponentElement<any> {
        const icon: JSX.Element = React.cloneElement(this.props.icon, {
            filled: this.state.filled,
            className: styles.bwIcon
        });

        return (
            <Anchor
                className={this.props.className}
                onClick={this.props.onClick?.bind(this)}
                onMouseEnter={() => this.setState({ filled: true })}
                onMouseLeave={() => this.setState({ filled: false })}
            >
                {icon}
            </Anchor>
        );
    }
}
